import React, { PropsWithChildren } from 'react';
import { Checkbox } from '@bedrock/components';
import './index.less';

//自定义受控组件
export type PropsType = {
  view?: boolean;
  value?: string;
  editable?: boolean;
  onChange?: (value: string) => void;
  column?: any;
  row?: any;
  rowIndex?: number;
  disabled?: boolean;
  onCheck?: (value: string) => Promise<boolean>;
};

export default function SingleCheckbox({
  value,
  onChange,
  view = false,
  children,
  editable,
  onCheck,
  ...rest
}: PropsWithChildren<PropsType>) {
  if (!editable || view) {
    if (typeof rest?.column?.render === 'function') {
      return rest.column.render(value, rest.row, rest.rowIndex);
    }
  }

  const handleChange = (e) => {
    const checked = e?.target?.checked;
    if (checked && onCheck) {
      onCheck(checked)
        .then((res) => {
          onChange?.(checked);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      onChange?.(checked);
    }
  };

  return (
    <Checkbox
      checked={value}
      {...rest}
      disabled={rest?.disabled || editable === false}
      onChange={handleChange}
    >
      {children}
    </Checkbox>
  );
}
